import { render } from "./ComponenteElecPreciosHistoricos.vue?vue&type=template&id=6bb84492&scoped=true"
import script from "./ComponenteElecPreciosHistoricos.vue?vue&type=script&lang=js"
export * from "./ComponenteElecPreciosHistoricos.vue?vue&type=script&lang=js"

import "./ComponenteElecPreciosHistoricos.vue?vue&type=style&index=0&id=6bb84492&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb84492"]])

export default __exports__